export abstract class EventBase {
    protected constructor() { }
}
